export default __webpack_public_path__ + "static/media/no_patient.9a99e7f0.png";